import theme from "styled-theming";
import {css} from "styled-components";

export const COLOR = {
  gray900: '#212529',
  gray800: '#343A40',
  gray700: '#495057',
  gray600: '#6C757D',
  gray500: '#A4ACB6',
  gray400: '#CED4DA',
  gray300: '#DEE2E6',
  gray200: '#E9ECEF',
  gray100: '#F8F9FA',
  white: '#ffffff',
  black: '#000000'
}

export const bgBody = theme('mode', {
  light: COLOR.white,
  dark: COLOR.gray900
});

export const linkColor = theme('mode', {
  light: css`
    color: ${COLOR.gray600};
    transition: all 200ms ease-in-out;

    :hover {
      color: ${COLOR.gray900};
    }
  `,
  dark: css`
    color: ${COLOR.gray500};
    transition: all 200ms ease-in-out;

    :hover {
      color: ${COLOR.white};
    }
  `,
});

export const gray900 = theme('mode',{
  light: COLOR.gray900,
  dark: COLOR.gray100
});

export const gray800 = theme('mode',{
  light: COLOR.gray800,
  dark: COLOR.gray200
});

export const gray700 = theme('mode',{
  light: COLOR.gray700,
  dark: COLOR.gray300
});

export const gray600 = theme('mode',{
  light: COLOR.gray600,
  dark: COLOR.gray400
});

export const gray500 = theme('mode',{
  light: COLOR.gray500,
  dark: COLOR.gray600
});

export const gray400 = theme('mode',{
  light: COLOR.gray400,
  dark: COLOR.gray600
});

export const gray300 = theme('mode',{
  light: COLOR.gray300,
  dark: COLOR.gray700
});

export const gray200 = theme('mode',{
  light: COLOR.gray200,
  dark: COLOR.gray800
});

export const gray100 = theme('mode',{
  light: COLOR.gray100,
  dark: COLOR.gray900
});
